export default {
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Number],
      default: '',
    },

    prependIcon: {
      type: String,
      default: '',
    },

    appendIcon: {
      type: String,
      default: '',
    },

    variant: {
      type: String,
      default: '',
    },

    floatingLabel: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    },

    iconClicked(event) {
      const icon = event.target.dataset.icon
      this.$emit(`click:${icon}`, event)
    },
  },
  computed: {
    filledClass() {
      return this.value && 'app-input--filled'
    },

    inputType() {
      return this.$attrs.type ? `app-input--${this.$attrs.type}` : 'app-input--text'
    },

    inputVariant() {
      return this.variant && `app-input-field--${this.variant}`
    },

    floatingLabelClass() {
      return this.floatingLabel && 'floating-label'
    },

    prependClass() {
      return this.prependIcon && 'icon-prepend'
    },

    appendClass() {
      return this.appendIcon && 'icon-append'
    },
  },
}
